import DemoApp from "./apps/DemoApp";
import useParamValues from "./utils/useParamValues";
import * as Sentry from "@sentry/react";
import { UrlConstants } from "./utils/CommonUtils/constants";

Sentry.init({
  dsn: UrlConstants.DSN_SENTRY_URL,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: process.env.REACT_APP_ENVIRONMENT,
  debug: false,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function App() {
  const { organisation } = useParamValues();
  
  return <DemoApp organisation={organisation} />;
}

export default App;
